import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';
import { ImgClick } from '../utility';
import { PLAYER_COLOR } from './constants';
import ImageAnimation from '../utils/ImageAnimation';
import timeClickedSound from './sounds/time-clicked.mp3';
import UIFx from 'uifx';
import { useShortcut } from '../../utils/useShortcut';
import startGameSound from './sounds/start-game.mp3';
import raceTimerIntroSound from './sounds/race-timer-into.mp3';
import AnimationWithSound from '../utils/AnimationWithSound';
import matchNotSaveFile from './sounds/match-not-save.mp3';
const timeClickedSoundFx = new UIFx(timeClickedSound);
const startGameSoundFx = new UIFx(startGameSound);
const matchNotSaveSound = new UIFx(matchNotSaveFile);

const TIMER_DURATION = [30 * 60, 45 * 60, 60 * 60, 75 * 60, 90 * 60];

const CLOCK_STATE = {
  INIT: 'init',
  RUNNING: 'running',
  PAUSED: 'paused',
  FINISH: 'finish',
};

const RESULTS = {
  WIN: 'win',
  LOSE: 'lose',
};

const TURN = {
  BLACK: 'black',
  WHITE: 'white',
};

const RaceTimer = ({
  handleBack,
  player,
  competitor,
  playerColor,
  handleWin,
  handleLose,
  config,
}) => {
  const { images } = useImagesContext();
  const [turn, setTurn] = useState(TURN.WHITE);
  const [settingTime, setSettingTime] = useState(TIMER_DURATION[0]);
  const [settingTimeIndex, setSettingTimeIndex] = useState(0);
  const [blackTime, setBlackTime] = useState(null);
  const [whiteTime, setWhiteTime] = useState(null);
  const [clockState, setClockState] = useState(CLOCK_STATE.INIT);
  const [blackResult, setBlackResult] = useState(RESULTS.NOT_FINISHED);
  const [whiteResult, setWhiteResult] = useState(RESULTS.NOT_FINISHED);
  const [into, setInto] = useState(true);
  const notSaved = useRef(true);
  const [displayImage, setDisplayImage] = useState(null);
  const isSaving = useRef(false);

  useShortcut('1', () => {
    handleBlackButtonClick();
  });

  useShortcut('2', () => {
    handlePause();
  });

  useShortcut('3', () => {
    handleWhiteButtonClick();
  });

  //   const [isRunning, setIsRunning] = useState(false);
  //   const [time, setTime] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setInto(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let interval;
    if (clockState === CLOCK_STATE.RUNNING) {
      if (turn === TURN.BLACK) {
        interval = setInterval(() => {
          setBlackTime((prev) => (prev !== null ? prev - 1 : 0));
          if (blackTime !== null && blackTime <= 0) {
            setBlackResult(RESULTS.LOSE);
            setWhiteResult(RESULTS.WIN);
            setClockState(CLOCK_STATE.FINISH);
          }
        }, 1000);
      } else if (turn === TURN.WHITE) {
        interval = setInterval(() => {
          setWhiteTime((prev) => (prev !== null ? prev - 1 : 0));
          if (whiteTime !== null && whiteTime <= 0) {
            setWhiteResult(RESULTS.LOSE);
            setBlackResult(RESULTS.WIN);
            setClockState(CLOCK_STATE.FINISH);
          }
        }, 1000);
      }
    }
    return () => clearInterval(interval);
  }, [turn, clockState]);

  //   const handleStart = () => setIsRunning(true);
  //   const handlePause = () => setIsRunning(false);
  //   const handleReset = () => {
  //     setTime(0);
  //     setIsRunning(false);
  //   };

  //   const formatTime = (seconds) => {
  //     const mins = Math.floor(seconds / 60);
  //     const secs = (seconds % 60).toFixed(2);
  //     return `${mins}:${secs.padStart(5, '0')}`;
  //   };

  const handleSave = () => {
    console.debug('handleSave called with clockState:', clockState);
    if (
      clockState === CLOCK_STATE.PAUSED ||
      clockState === CLOCK_STATE.RUNNING
    ) {
      // setTurn(null);
      setClockState(CLOCK_STATE.FINISH);
      setBlackTime(null);
      setWhiteTime(null);
    } else if (clockState === CLOCK_STATE.FINISH) {
      if (isSaving.current) return;
      isSaving.current = true;
      console.debug(`blackResult: ${blackResult}`);
      console.debug(`whiteResult: ${whiteResult}`);
      if (playerColor === PLAYER_COLOR.BLACK) {
        if (blackResult === RESULTS.WIN) {
          handleWin();
        } else if (blackResult === RESULTS.LOSE) {
          handleLose();
        }
      } else if (playerColor === PLAYER_COLOR.WHITE) {
        if (whiteResult === RESULTS.WIN) {
          handleWin();
        } else if (whiteResult === RESULTS.LOSE) {
          handleLose();
        }
      }
    }
  };
  const handlePause = () => {
    if (clockState === CLOCK_STATE.RUNNING) {
      setClockState(CLOCK_STATE.PAUSED);
    } else if (clockState === CLOCK_STATE.PAUSED) {
      setClockState(CLOCK_STATE.RUNNING);
    }
  };

  const handleThisBack = () => {
    console.debug(
      'handleThisBack called with notsave:',
      notSaved.current,
      'and clockState:',
      clockState,
    );
    if (
      (clockState === CLOCK_STATE.FINISH ||
        clockState === CLOCK_STATE.PAUSED ||
        clockState === CLOCK_STATE.RUNNING) &&
      notSaved.current === true
    ) {
      setDisplayImage(images['timer-not-save.png']);
      if (config.isMutedSound === false) {
        matchNotSaveSound.play();
      }
      notSaved.current = false;
      setTimeout(() => {
        setDisplayImage(null);
        setTimeout(() => {
          notSaved.current = true;
        }, 3000);
      }, 2000);
    } else {
      handleBack();
    }
  };

  const PlayerInfo = ({
    result,
    avatar,
    time,
    isBlack,
    handleTimeClick,
    handleSetResult,
  }) => {
    return (
      <>
        <PlayerAvatar src={avatar} />
        <ImageBorder
          onClick={handleSetResult}
          src={images['timer-image-border.png']}
        />
        {result && <PlayerResult src={images[`timer-${result}.png`]} />}
        <PlayerTime isBlack={isBlack} onClick={handleTimeClick}>
          {time}
        </PlayerTime>
      </>
    );
  };

  const toTimeString = (seconds) => {
    if (seconds === null) return '--.--';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}.${String(secs).padStart(2, '0')}`;
  };

  const handleSetResult = (playerColor) => {
    if (clockState != CLOCK_STATE.FINISH) return;
    if (playerColor === PLAYER_COLOR.BLACK) {
      if (blackResult === RESULTS.NOT_FINISHED) {
        setBlackResult(RESULTS.WIN);
        setWhiteResult(RESULTS.LOSE);
      } else if (blackResult === RESULTS.WIN) {
        setBlackResult(RESULTS.LOSE);
        setWhiteResult(RESULTS.WIN);
      } else if (blackResult === RESULTS.LOSE) {
        setBlackResult(RESULTS.WIN);
        setWhiteResult(RESULTS.LOSE);
      }
    } else if (playerColor === PLAYER_COLOR.WHITE) {
      if (whiteResult === RESULTS.NOT_FINISHED) {
        setWhiteResult(RESULTS.WIN);
        setBlackResult(RESULTS.LOSE);
      } else if (whiteResult === RESULTS.WIN) {
        setWhiteResult(RESULTS.LOSE);
        setBlackResult(RESULTS.WIN);
      } else if (whiteResult === RESULTS.LOSE) {
        setWhiteResult(RESULTS.WIN);
        setBlackResult(RESULTS.LOSE);
      }
    }
  };

  const handleBlackButtonClick = () => {
    if (clockState !== CLOCK_STATE.RUNNING) return;
    if (turn === PLAYER_COLOR.BLACK) {
      if (config.isMutedSound === false) {
        timeClickedSoundFx.play();
      }
      setTurn(PLAYER_COLOR.WHITE);
    }
  };

  const handleWhiteButtonClick = () => {
    if (clockState !== CLOCK_STATE.RUNNING && clockState !== CLOCK_STATE.INIT)
      return;
    if (turn === PLAYER_COLOR.WHITE) {
      if (config.isMutedSound === false) {
        timeClickedSoundFx.play();
      }
      setTurn(PLAYER_COLOR.BLACK);
    }
    if (clockState === CLOCK_STATE.INIT) {
      setWhiteTime(settingTime);
      setBlackTime(settingTime);
      if (config.isMutedSound === false) {
        startGameSoundFx.play();
      }
      setClockState(CLOCK_STATE.RUNNING);
      setTurn(PLAYER_COLOR.BLACK);
    }
  };

  return (
    <Container>
      <BackgroundImage
        src={images['race-background.jpg']}
        alt="race time background"
      />
      {turn !== null && (
        <Thingking
          src={images['timer-thinking.png']}
          isFlipped={turn === PLAYER_COLOR.BLACK}
        />
      )}
      <BoardImage src={images['timer-board.png']} />
      <PlayerBlack>
        <PlayerInfo
          isBlack={playerColor === PLAYER_COLOR.BLACK}
          result={blackResult}
          avatar={
            playerColor === PLAYER_COLOR.BLACK
              ? player?.avatar
              : competitor?.avatar
          }
          handleSetResult={() => handleSetResult(PLAYER_COLOR.BLACK)}
          handleTimeClick={() => {
            if (clockState === CLOCK_STATE.INIT) {
              const nextIndex = (settingTimeIndex + 1) % TIMER_DURATION.length;
              setSettingTimeIndex(nextIndex);
              setSettingTime(TIMER_DURATION[nextIndex]);
            }
          }}
          time={
            clockState === CLOCK_STATE.INIT
              ? toTimeString(settingTime)
              : toTimeString(blackTime)
          }
        />
      </PlayerBlack>
      <PlayerWhite>
        <PlayerInfo
          isBlack={playerColor === PLAYER_COLOR.BLACK}
          result={whiteResult}
          avatar={
            playerColor === PLAYER_COLOR.BLACK
              ? competitor?.avatar
              : player?.avatar
          }
          handleSetResult={() => handleSetResult(PLAYER_COLOR.WHITE)}
          handleTimeClick={() => {
            const nextIndex = (settingTimeIndex + 1) % TIMER_DURATION.length;
            setSettingTimeIndex(nextIndex);
            setSettingTime(TIMER_DURATION[nextIndex]);
          }}
          time={
            clockState === CLOCK_STATE.INIT
              ? toTimeString(settingTime)
              : toTimeString(whiteTime)
          }
        />
      </PlayerWhite>
      <BlackButton
        // onClick={() => {
        //   if (turn === PLAYER_COLOR.BLACK) {
        //     setTurn(PLAYER_COLOR.WHITE);
        //   }
        // }}
        src={images['timer-black-button.png']}
      />
      <WhiteButton
        // onClick={() => {
        //   if (clockState === CLOCK_STATE.FINISH) return;
        //   if (turn === null) {
        //     setWhiteTime(settingTime);
        //     setBlackTime(settingTime);
        //   }
        //   setTurn(PLAYER_COLOR.BLACK);
        //   setClockState(CLOCK_STATE.RUNNING);
        // }}
        src={images['timer-white-button.png']}
      />
      {turn === PLAYER_COLOR.BLACK && clockState === CLOCK_STATE.RUNNING && (
        <BlackButtonActive
          onClick={handleBlackButtonClick}
          src={images['timer-black-active.png']}
        />
      )}
      {((turn === PLAYER_COLOR.WHITE && clockState === CLOCK_STATE.RUNNING) ||
        clockState === CLOCK_STATE.INIT) && (
        <WhiteButtonActive
          onClick={handleWhiteButtonClick}
          src={images['timer-white-active.png']}
        />
      )}
      <ButtonContainer>
        <Button onClick={handleThisBack} src={images['timer-back.png']} />
        <Button onClick={handlePause} src={images['timer-pause.png']} />
        <Button onClick={handleSave} src={images['timer-save.png']} />
      </ButtonContainer>
      {into && (
        <>
          <BackgroundImage
            src={images['race-background.jpg']}
            alt="background"
          />
          <AnimationWithSound
            imageUrl={images['timer-effect-01.png']}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: 1920,
              height: 1080,
            }}
            soundFile={raceTimerIntroSound}
            playSound={config.isMutedSound === false}
          />
          <ImageAnimation
            imageUrl={images['timer-effect-02.png']}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: 1920,
              height: 1080,
            }}
          />
        </>
      )}
      {displayImage && <DisplayImage src={displayImage} alt="display image" />}
    </Container>
  );
};

const DisplayImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0px;
  display: flex;
  gap: 0px;
  left: 722px;
`;

const Button = styled(ImgClick)`
  //   position: absolute;
  //   bottom: 20px;
  //   left: 20px;
`;

const BoardImage = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
`;

const PlayerBlack = styled.div`
  position: absolute;
  top: 118px;
  left: 90px;
`;

const PlayerWhite = styled.div`
  position: absolute;
  top: 118px;
  right: 326px;
`;

const PlayerAvatar = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 239px;
  height: 239px;
  border-radius: 50%;
`;

const ImageBorder = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
`;

const PlayerResult = styled.img`
  position: absolute;
  top: 216px;
  left: -26px;
`;

const PlayerTime = styled.div`
  position: absolute;
  top: 260px;
  left: 0px;
  font-family: 'PSLxText';
  font-weight: bold;
  font-size: 140px;
  text-align: center;
  width: 250px;
  paint-order: stroke fill;
  color: ${(props) => (props.isBlack ? 'black' : 'white')};
  -webkit-text-stroke: ${(props) =>
    props.isBlack ? '0.05em white' : '0.07em black'};
`;

const BlackButton = styled(ImgClick)`
  position: absolute;
  left: 462px;
  bottom: 0px;
`;

const WhiteButton = styled(ImgClick)`
  position: absolute;
  left: 1260px;
  bottom: 0px;
`;

const BlackButtonActive = styled.img`
  position: absolute;
  left: 446px;
  bottom: 0px;
`;

const WhiteButtonActive = styled.img`
  position: absolute;
  left: 1252px;
  bottom: 0px;
`;

const Thingking = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  transform: ${(props) => (props.isFlipped ? 'scaleX(-1)' : 'none')};
`;

export default RaceTimer;
